export default function setLocalCacheVersions(versions) {
  return window.localStorage.setItem('cacheVersion', JSON.stringify(versions))
}
